import { render, staticRenderFns } from "./AddPrograme.vue?vue&type=template&id=3b091693&"
import script from "./AddPrograme.vue?vue&type=script&lang=js&"
export * from "./AddPrograme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports